import {Component, Input, OnInit} from "@angular/core";
import {ValidationHelperService} from "../../../../../../../core/helpers/validation-helper.service";
import {Country, ICity, IState} from "../../../../../../../core/models/geography.model";
import {IAddressForm} from "../../../../core/forms/account-information/account-information-form.interface";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {IAddress} from "../../../../../../../core/api/controllers/account-controller/interfaces/get-account-information.response";
import {AddressFormFactory} from "../../../../core/forms/account-information/account-information-form.factory";
import {GeographyControllerService} from "../../../../../../../core/api/controllers/geography-controller.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatAutocompleteModule, MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {BehaviorSubject} from "rxjs";
import {MatInputModule} from "@angular/material/input";
import {NgForOf, NgIf} from "@angular/common";
import {AutocompletePositionModule} from "../../../../../../../shared/directives/autocomplete-position/autocomplete-position.module";

@Component({
    selector: "app-address-form",
    templateUrl: "./address-form.component.html",
    styleUrls: ["./address-form.component.scss"],
    standalone: true,
    imports: [MatInputModule, ReactiveFormsModule, MatAutocompleteModule, NgIf, NgForOf, AutocompletePositionModule]
})
export class AddressFormComponent implements OnInit{
    protected readonly ValidationHelperService = ValidationHelperService;
    @Input() _form: FormGroup<IAddressForm>;
    @Input() prefillInformation: IAddress;
    @Input() $triggerCopyShipping: BehaviorSubject<IAddress>;
    countries: Country[] = [];
    filteredCountries: Country[] = [];

    states: IState[] = [];
    filteredStates: IState[] = [];

    cities: ICity[] = [];
    filteredCities: ICity[] = [];

    constructor(
        private geographyControllerService: GeographyControllerService,
        private matSnackbar: MatSnackBar
    ) {}

    ngOnInit(): void {
        this.prefillForm(this.prefillInformation);
        this.$triggerCopyShipping?.subscribe((prefillInformation) => {
            if(prefillInformation)
            this.prefillForm(prefillInformation);
        })
    }


    prefillForm(prefillInformation: IAddress): void {
        AddressFormFactory.patchValue(this._form, prefillInformation);
        this.getCountries(prefillInformation.country as Country);
        this.getStates(prefillInformation.country.id, prefillInformation.state);
        this.getCities(prefillInformation.state.id, prefillInformation.city);
    }

    getCountries(prefillCountry: Country = null) {
        this._form.controls.country.disable();
        this.geographyControllerService.getAllCountries().subscribe(
            (response) => {
                this.countries = response;
                this.filterCountries(prefillCountry?.name);
                if(prefillCountry) {
                    this._form.controls.country.setValue(this.filteredCountries.find(country => country.id === prefillCountry.id));
                }
                this._form.controls.country.enable();
            },
            () => {
                this.matSnackbar.open("There was an error retrieving the countries. Please close this popup and open it again.")
            },
        );
    }

    inputFilterCountries(event: any): void {
        this.filterCountries(event.target.value as string);
    }

    filterCountries(value: string): void {
        if(!value) return;
        const filterValue = value.toLowerCase();
        this.filteredCountries =  this.countries.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    displayCountry(country: Country): string {
        return country?.name;
    }

    selectCountry(event: MatAutocompleteSelectedEvent): void {
        const value = event.option.value as Country;
        this._form.controls.state.setValue(null);
        this._form.controls.city.setValue(null);
        this.cities = [];
        this.filteredCities = [];
        this.states = [];
        this.filteredStates = [];
        this.getStates(value.id);
    }

    getStates(countryId: string, prefillState: IState = null) {
        this._form.controls.state.disable();
        this.geographyControllerService.getStatesByCountry(countryId).subscribe({
            next: (response) => {
                this.states = response;
                this.filterStates(prefillState?.name ?? '');
                if(prefillState) {
                    this._form.controls.state.setValue(this.filteredStates.find(country => country.id === prefillState.id));
                }
                this._form.controls.state.enable();
            },
            error: () => {
                this.matSnackbar.open("There was an error retrieving the states. Please close this popup and open it again.");
            }
        });
    }

    inputFilterStates(event: any): void {
        this.filterStates(event.target.value as string ?? '');
    }

    filterStates(value: string): void {
        const filterValue = value.toLowerCase();
        this.filteredStates =  this.states.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    displayState(state: IState): string {
        return state?.name;
    }

    selectState(event: MatAutocompleteSelectedEvent): void {
        const value = event.option.value as IState;
        this._form.controls.city.setValue(null);
        this.cities = [];
        this.filteredCities = [];
        this.getCities(value.id);
    }

    getCities(stateId: string, prefillCity: ICity = null) {
        this._form.controls.city.disable();
        this.geographyControllerService.getCitiesByState(stateId).subscribe({
            next: (response) => {
                this.cities = response;
                if(prefillCity) {
                    if(!this.cities.find(c => c.id === prefillCity.id)) {
                        this.cities.push(prefillCity);
                        this.cities.sort((c1, c2) => c1.name < c2.name ? -1 : 1);
                    }
                    this.filterCities(prefillCity?.name ?? '');
                    this._form.controls.city.setValue(this.filteredCities.find(country => country.id === prefillCity.id));
                }
                this._form.controls.city.enable();
            },
            error: () => {
                this.matSnackbar.open("There was an error retrieving the cities. Please close this popup and open it again.");
            }
        });
    }

    inputFilterCities(event: any): void {
        this.filterCities(event.target.value as string ?? '');
    }

    filterCities(value: string): void {
        const filterValue = value.toLowerCase();
        this.filteredCities =  this.cities.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    displayCity(city: ICity): string {
        return city?.name;
    }

}
